import { FaEnvelope, FaFacebookF, FaInstagram, FaLinkedin, FaMapMarkerAlt, FaPhoneAlt,FaWhatsapp } from "react-icons/fa";
import { GridContainer, MainButton} from "../../global";
import { Logo } from "../Header/style";
import { ContentInfo, ContentMenus, MainFooter,ReclameAquiImage, HighlightSocialFooter,  MenuBox, SectionFooter, SocialFooter, TextParagraphFooter } from "./style";
import { FaXTwitter } from "react-icons/fa6";

export function Footer() {

     const whatsappLink = "https://wa.me/551151966625";
    return(
        <MainFooter>
            <GridContainer>
                <SectionFooter>
                    <ContentInfo>
                        <Logo src="/logo-renovera-footer.png" />
                        {/* <SocialFooter>
                            <li><a href="https://www.facebook.com/profile.php?id=61564525426127" target="blank_"><FaFacebookF /></a></li>
                            <li><a href="#" target="blank_"><FaXTwitter /></a></li>
                            <li><a href="https://www.linkedin.com/company/renoverabr" target="blank_"><FaLinkedin /></a></li>
                            <li><a href="https://www.instagram.com/renoveraoficial/" target="blank_"><FaInstagram /></a></li>
                        </SocialFooter> */}
                        <TextParagraphFooter>A Renovera está ao lado do integrador na busca pelas melhores 
                            condições em equipamentos fotovoltaicos, conectando-o a mais de 10 distribuidoras parceiras. Contamos com uma equipe técnica multidisciplinar, especializada na reversão de indeferimentos por inversão de fluxo, com atuação consultiva no âmbito administrativo e judicial. Com excelência técnica, ética e atendimento humanizado, 
                            oferecemos soluções completas e personalizadas para o dia a dia do integrador.</TextParagraphFooter>
                        <MainButton href="https://www.renovera.com.br/cadastro">Cadastre-se</MainButton>

                        <a href="https://www.reclameaqui.com.br/empresa/renovera-energias-renovaveis-ltda/" target="_blank" rel="noopener noreferrer">
                            <ReclameAquiImage src="/ReclameAqui.png" alt="Selo Reclame Aqui" />
                        </a>
                    </ContentInfo>
                    <ContentMenus>
                        <MenuBox>
                            <h4>Páginas</h4>
                            <ul>
                                <li><a href="#">Home</a></li>
                                <li><a href="/quemsomos">Quem somos</a></li>
                                <li><a href="/blog">Blog</a></li>
                                <li><a href="/faq">FAQ</a></li>
                                <li><a href="#">Trabalhe conosco</a></li>
                                <li><a href="/fale-conosco">Contato</a></li>
                            </ul>
                        </MenuBox>
                        <MenuBox>
                            <h4>Serviços</h4>
                            <ul>
                                <li><a href="https://integrador.renovera.com.br/">Plataforma</a></li>
                                <li><a href="https://renovera.com.br/cadatro#scrollTop=0">Cadastro</a></li>
                                <li><a href="#">Mercado Renovera</a></li>
                                <li><a href="https://renovera.com.br/termos-de-uso">Termos de uso</a></li>
                            </ul>
                        </MenuBox>
                        <MenuBox>
                            <h4>Contato</h4>
                            <ul>
                                <li><FaPhoneAlt size={18} style={{marginRight: "10px", marginBottom: "-3px"}} /> +55 (11) 5196-6625</li>
                                <li><FaEnvelope size={18} style={{marginRight: "10px", marginBottom: "-3px"}} /> renovera@renovera.com.br</li>
                                <li><FaMapMarkerAlt size={18} style={{marginRight: "10px", marginBottom: "-3px"}} /> Rua Gabriel Ferreira, n.29, Sala 12 - Centro - São João da Boa Vista/SP - Cep: 13870-180.</li>
                            </ul>
                              <HighlightSocialFooter>
                                <a href="https://www.linkedin.com/company/renoverabr" target="_blank" rel="noopener noreferrer" title="LinkedIn"><FaLinkedin /></a>
                                <a href={whatsappLink} target="_blank" rel="noopener noreferrer" title="WhatsApp"><FaWhatsapp /></a>
                                <a href="https://www.instagram.com/renoveraoficial/" target="_blank" rel="noopener noreferrer" title="Instagram"><FaInstagram /></a>
                            </HighlightSocialFooter>
                        </MenuBox>
                    </ContentMenus>
                </SectionFooter>
            </GridContainer>
        </MainFooter>
    )
}